import { nameSchema } from 'shared/components/vxl/input/schemas/name.schema';
import { z } from 'zod';

export const PersonalInfoSchema = z.object({
  firstName: nameSchema,
  lastName: nameSchema,
});
